import * as React from "react";
import { ConfirmationModal } from '../../base/confirmationmodal';
import { MenuItemProps, MenuItem } from '../../menu/menuitem';
import { BodyHeader } from '../../base/bodyheader';
import { Location } from '../../../store/locations/LocationEntities';
import { ConnectedLocationForm } from '../connected/connected.form';
import { ConnectedMainDocuments } from '../../documents/connected.maindocuments';
import { UnsavedChanges } from "../../base/unsavedchanges";

export interface LocationEditPageProps {
    location?: Location;
}

export interface LocationEditPageCallbacks {
    onLoad: (id: string) => void;
    onDelete: () => void;
    onSubmit?: () => void;
}


export class LocationEditPage extends React.Component<LocationEditPageProps & LocationEditPageCallbacks>{
    private modalRef: React.RefObject<ConfirmationModal>;
    constructor(props) {
        super(props);
        this.modalRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.onLoad) {
            let id = null;
            if ((this.props as any).match !== undefined && (this.props as any).match != null && (this.props as any).match.params !== undefined && (this.props as any).match.params != null)
                id = (this.props as any).match.params.id;
            this.props.onLoad(id);
        }
    }

    private delete() {
        if (this.props.onDelete)
            this.props.onDelete();
    }

    render() {

        if (this.props.location === undefined || this.props.location == null) {
            return (<React.Fragment></React.Fragment>);
        }

        let isNew = true;

        let menuItems = [];

        if (this.props.location.id !== undefined && this.props.location.id != null) {
            menuItems = [
                {
                    icon: "trash",
                    label: "elimina",
                    isButton: true,
                    isDisabled: false,
                    onClick: () => { this.modalRef.current.toogleModal() }
                }
            ] as Array<MenuItemProps>

            isNew = false;
        }

        menuItems.push({
            icon: "list",
            label: "lista",
            isButton: false,
            isSmall: true,
            path: "/locations"
        } as MenuItemProps);

        let documents = null;
        if (this.props.location !== undefined && this.props.location != null && this.props.location.id !== undefined && this.props.location.id != null)
            documents = (<ConnectedMainDocuments objectId={this.props.location.id} objectName={`${this.props.location.name} `} />);


        return (
            <React.Fragment>
                <UnsavedChanges confirmAction={this.props.onSubmit} />
                <BodyHeader title={isNew == true ? "Crea Hotel" : "Modifica Hotel"} menuItems={menuItems} />
                <ConnectedLocationForm />
                <ConfirmationModal text="Eliminare Hotel?" onConfirm={() => this.delete()} ref={this.modalRef} />
                {documents}
            </React.Fragment>
        )
    }
}